import script from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=4d461ba6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d461ba6"]])

export default __exports__